import { createStyles, makeStyles } from '@material-ui/core';
import { white } from 'Material-UI/colors';

const sharedStyles = createStyles({
  spaceTitle: {
    fontFamily: 'Roboto',
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: 'bold',
    paddingBlock: '10px',
  },
  oval: {
    height: '90px',
    width: '90px',
    background: 'linear-gradient(35.77deg, #96C851 0%, #4C9722 100%)',
    boxShadow: '4px 4px 15px 0 rgba(0,0,0,0.2)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
const userStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'auto',
  },
  paper: (isMobile) => ({
    marginTop: isMobile ? '500px' : '0px',
    background: 'linear-gradient(to bottom, #0075C9 160px, white 0%);',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
    borderRadius: '4px',
    outline: 'none',
    maxWidth: isMobile ? '85%' : '75%',
    minHeight: '50%',
    padding: 30,
  }),
  backdrop: {
    background: 'rgba(0,0,0,0.6)',
  },
  header: {
    height: '50px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  header_title: {
    textAlign: 'center',
    fontSize: '18px',
    color: white,
    fontFamily: 'Roboto',
  },
  spacesContainer: {
    alignItems: 'stretch',
    paddingBottom: '20px',
  },
  spaceContainer: (isMobile) => ({
    marginTop: '10px',
    width: '500px',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxShadow: ' 0 1px 1px 0 rgba(0,0,0,0.03), 0 0 24px 0 rgba(0,0,0,0.08)',
    padding: isMobile ? 10 : 20,
  }),
  spaceHeader: {
    display: 'flex',
    justifyContent: 'center',
  },
  spaceTitle: (isMobile) => ({
    ...sharedStyles.spaceTitle,
    ...(isMobile && { fontSize: '16px' }),
    paddingBlock: '5px',
  }),
  amcTitle: (isMobile) => ({
    ...sharedStyles.spaceTitle,
    ...(isMobile && { fontSize: '16px' }),
    paddingBlock: '5px',
    marginTop: !isMobile ? '25px' : '0px',
    paddingBottom: !isMobile ? '28px' : '0px',
  }),
  ocpTitle: (isMobile) => ({
    ...sharedStyles.spaceTitle,
    ...(isMobile && { fontSize: '16px' }),
    paddingBlock: '5px',
    marginTop: !isMobile ? '25px' : '0px',
  }),
  list: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    lineHeight: '25px',
  },
  otherSpaceBody: {
    paddingBottom: 1,
  },
  healthIconOval: sharedStyles.oval,
  ocpIconOval: {
    ...sharedStyles.oval,
    background: white,
  },
  icon: {
    height: '50px',
    width: '50px',
  },
  iconsNec: {
    height: '120px',
  },
  buttonContainer: (isMobile) => ({
    marginTop: isMobile ? 5 : 30,
  }),
  ocpLogo: {
    width: '80px',
  },
});

export default userStyles;
